import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Header from '@components/Header';
import Footer from '@components/Footer';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const styles = theme => ({
  root: {
    paddingTop: 58,
  },
  contentContainer: {
    paddingTop: 55,
    paddingBottom: 55,
  },
});

const Index = ({ classes }) => {
  return (
    <div className={classes.root}>
      <Head>
        <title>Privacy Policy - SellOnLive</title>
      </Head>
      <Header />
      <div className={['container', classes.contentContainer].join(' ')}>
        <h1>SellOnLive Tech Privacy Policy</h1>
        <p>
          This Privacy Policy describes how your personal information is collected, used, and shared
          when you visit or make a purchase from sellonlive.tech (the “Site”).
        </p>
        <br />

        <p>PERSONAL INFORMATION WE COLLECT</p>
        <p>
          When you visit the Site, we automatically collect certain information about your device,
          including information about your web browser, IP address, time zone, and some of the
          cookies that are installed on your device. Additionally, as you browse the Site, we
          collect information about the individual web pages or products that you view, what
          websites or search terms referred you to the Site, and information about how you interact
          with the Site. We refer to this automatically-collected information as “Device
          Information.”
        </p>

        <p>We collect Device Information using the following technologies:</p>
        <p>
          - “Cookies” are data files that are placed on your device or computer and often include an
          anonymous unique identifier. For more information about cookies, and how to disable
          cookies, visit http://www.allaboutcookies.org.
        </p>

        <p>
          - “Log files” track actions occurring on the Site, and collect data including your IP
          address, browser type, Internet service provider, referring/exit pages, and date/time
          stamps.
        </p>

        <p>
          - “Web beacons,” “tags,” and “pixels” are electronic files used to record information
          about how you browse the Site.
        </p>

        <p>
          Additionally when you make a purchase or attempt to make a purchase through the Site, we
          collect certain information from you, including your name, billing address, shipping
          address, payment information (including credit card numbers), email address, and phone
          number. We refer to this information as “Order Information.”
        </p>

        <p>
          When we talk about “Personal Information” in this Privacy Policy, we are talking both
          about Device Information and Order Information.
        </p>
        <br />

        <p>HOW DO WE USE YOUR PERSONAL INFORMATION?</p>

        <p>
          We use the Order Information that we collect generally to fulfill any orders placed
          through the Site (including processing your payment information, arranging for shipping,
          and providing you with invoices and/or order confirmations). Additionally, we use this
          Order Information to: Communicate with you;
        </p>

        <p>
          Screen our orders for potential risk or fraud; and When in line with the preferences you
          have shared with us, provide you with information or advertising relating to our products
          or services.
        </p>

        <p>
          We use the Device Information that we collect to help us screen for potential risk and
          fraud (in particular, your IP address), and more generally to improve and optimize our
          Site (for example, by generating analytics about how our customers browse and interact
          with the Site, and to assess the success of our marketing and advertising campaigns).
        </p>
        <br />

        <p>SHARING YOUR PERSONAL INFORMATION</p>

        <p>
          We share your Personal Information with third parties to help us use your Personal
          Information, as described above. For example, we use Facebook to power our online
          store--you can read more about how Facebook uses your Personal Information here:
          https://www.facebook.com/policy.php. We also use Google Analytics to help us understand
          how our customers use the Site--you can read more about how Google uses your Personal
          Information here: https://www.google.com/intl/en/policies/privacy/. You can also opt-out
          of Google Analytics here: https://tools.google.com/dlpage/gaoptout.
        </p>

        <p>
          Finally, we may also share your Personal Information to comply with applicable laws and
          regulations, to respond to a subpoena, search warrant or other lawful request for
          information we receive, or to otherwise protect our rights.
        </p>

        <br />
        <p>BEHAVIOURAL ADVERTISING </p>
        <p>
          As described above, we use your Personal Information to provide you with targeted
          advertisements or marketing communications we believe may be of interest to you. For more
          information about how targeted advertising works, you can visit the Network Advertising
          Initiative’s (“NAI”) educational page at
          http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
        </p>

        <p>
          You can opt out of targeted advertising by: <br />
          FACEBOOK - https://www.facebook.com/settings/?tab=ads <br />
          GOOGLE - https://www.google.com/settings/ads/anonymous <br />
          BING - https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
          <br />
          Additionally, you can opt out of some of these services by visiting the Digital
          Advertising Alliance’s opt-out portal at: http://optout.aboutads.info/.
        </p>

        <p>
          DO NOT TRACK Please note that we do not alter our Site’s data collection and use practices
          when we see a Do Not Track signal from your browser.
        </p>

        <br />
        <p>YOUR RIGHTS</p>

        <p>
          If you are a European resident, you have the right to access personal information we hold
          about you and to ask that your personal information be corrected, updated, or deleted. If
          you would like to exercise this right, please contact us through the contact information
          below.
        </p>

        <p>
          Additionally, if you are a European resident we note that we are processing your
          information in order to fulfill contracts we might have with you (for example if you make
          an order through the Site), or otherwise to pursue our legitimate business interests
          listed above. Additionally, please note that your information will be transferred outside
          of Europe, including to Canada and the United States.
        </p>

        <br />
        <p>DATA RETENTION</p>

        <p>
          When you place an order through the Site, we will maintain your Order Information for our
          records unless and until you ask us to delete this information.
        </p>

        <p>
          We may update this privacy policy from time to time in order to reflect, for example,
          changes to our practices or for other operational, legal or regulatory reasons.
        </p>

        <br />
        <p>DATA DELETION REQUEST</p>

        <p>
          We are committed to providing transparency and ensuring that our users have control over
          their personal data. If you wish to delete your account or request the deletion of your
          personal data, you can do so by following the steps below:
        </p>

        <p>1. Email Request:</p>
        <p>
          Send an email to{' '}
          <a href="mailto:sellonlivetech@gmail.com?subject=Request for Account Data Deletion&body=Dear SellonLive Team,%0D%0A%0D%0AI am writing to request the deletion of my account and all associated personal data in compliance with applicable data protection regulations.%0D%0A%0D%0AHere are my account details for your reference:%0D%0A- Name: [Your Full Name]%0D%0A- Email Address: [Your Registered Email Address]%0D%0A%0D%0APlease confirm the successful deletion of my account and data or let me know if additional information is required to process this request.%0D%0A%0D%0AThank you for your assistance.%0D%0A%0D%0ABest regards,%0D%0A[Your Full Name]">
            sellonlivetech@gmail.com
          </a>{' '}
          with the subject line "Data Deletion Request" and include the following details in your
          message:
        </p>
        <ul>
          <li>Your full name</li>
          <li>Registered email address</li>
        </ul>
        <p>
          Once we receive your request, we will process it promptly and ensure your data is deleted
          within 30 days as required by applicable laws.
        </p>
        <br />
        <p>CONTACT US</p>

        <p>
          For more information about our privacy practices, if you have questions, or if you would
          like to make a complaint, please contact us by e-mail at help@sellonlive.tech or by mail
          using the details provided below:
        </p>

        <p>
          52-2, Jalan BS 1/1, Taman Bukit Serdang, Pusat Perdagangan Olive Hill, Sekysen 1, 43300
          Seri Kembangan Selangor
        </p>
      </div>
      <Footer />
    </div>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default withStyles(styles)(Index);
